export function PricingPage() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-4xl font-bold mb-4">Simple, Transparent Pricing</h1>
        <p className="text-xl text-gray-600 mb-12">
          No subscriptions. No commitments. Just pay when you submit.
        </p>
        {/* Pricing cards will go here */}
        <p className="text-gray-500">Pricing details coming soon.</p>
      </div>
    </section>
  );
}
